{
  "nl": {
    "sales": {
      "actions": {
        "assign_lead": "Lead toewijzen",
        "publish": "Publiceren",
        "remove_lead_from_deal": "Lead uit deal verwijderen",
        "unpublish": "Depubliceren",
        "update_status": "Status bijwerken",
        "upload_document": "Contract uploaden",
        "view_contracts": "Contracten bekijken"
      },
      "attributes": {
        "status": "Toestand"
      },
      "labels": {
        "assign_customer": "Klant toewijzen",
        "assign_customer_mark_sold": "Wijs klant toe om als verkocht te markeren",
        "assign_lead_to_unit": "Wijs lead toe aan unit",
        "assigned_by": "Toegekend door",
        "contracts": "Contracten",
        "expiry_date": "Vervaldatum reservering",
        "go_to_unit_part_1": "Deze unit is verkocht. Als u de status wilt bijwerken, gaat u naar de",
        "go_to_unit_part_2": "en maakt u de toewijzing van de klant daar eerst ongedaan als veiligheidsmaatregel.",
        "interested_leads": "{count} geïnteresseerde leads",
        "leads_count": "{count} leads",
        "internal_note": "Interne opmerking",
        "latest_phase": "Huidige fase",
        "lead_existing": "Bestaande lead",
        "lead_new": "Nieuwe lead",
        "mark_as_sold": "Markeer als verkocht",
        "not_published_sales_partners": "Niet gepubliceerd voor verkooppartners",
        "not_shown_interest": "Deze lead heeft in geen enkele unit interesse getoond",
        "note_explainer": "Deze notitie is alleen zichtbaar voor jouw team",
        "publish_unit": "Publiceer 1 unit voor alle verkooppartners | Publiceer {count} units voor alle verkooppartners",
        "published_sales_partners": "Gepubliceerd voor verkooppartners",
        "reserved_by": "Gereserveerd door",
        "reserved_warning": "Deze unit is momenteel gereserveerd door {lead_name}. Als u deze unit als verkocht markeert, wordt deze reservering geannuleerd.",
        "sales": "Verkoop",
        "selling_price": "Verkoopprijs",
        "selling_price_max": "Maximale verkoopprijs",
        "selling_price_min": "Minimale verkoopprijs",
        "sold_date": "Verkocht op",
        "sorting": {
          "deal_lead_group_name": "Lead",
          "deal_status": "Status",
          "name": "Unit naam"
        },
        "status": "Status",
        "statuses": {
          "available": "Beschikbaar",
          "interested": "Geïnteresseerd",
          "lost": "Verloren",
          "reserved": "Gereserveerd",
          "sold": "Verkocht"
        },
        "tab_sales_documents": "Documenten",
        "tab_sales_tickets": "Gesprekken",
        "tab_sales_units": "Units",
        "unit": "Unit",
        "unit_information_page": "unit informatie pagina",
        "unit_sales_status_header": "Deze unit staat te koop",
        "unpublish_unit": "Depubliceer 1 unit voor alle verkooppartners | Depubliceer {count} units voor alle verkooppartners",
        "update_sales_status": "Status van verkoop per eenheid bijwerken",
        "upload_sales_doc": "Contract uploaden"
      },
      "toasts": {
        "lead_assigned": "Lead toegewezen"
      },
      "validation": {
        "already_reserved_sold": "Deze unit is al gereserveerd voor of verkocht aan een andere lead!",
        "already_reserved_sold_info": "Als u zeker weet dat u de status van de huidige lead wilt wijzigen, moet u eerst de status wijzigen van de deal die momenteel prioriteit heeft. Zodra je de status van de andere deal hebt gewijzigd, kun je terugkomen en de status veilig bijwerken.",
        "need_sold_date": "Datum van verkoop is verplicht",
        "reserved_expiry_date": "Vervaldatum van deze reservering is verplicht"
      }
    }
  }
}
